export const skillsData = [
  "Python",
  "FastAPI",
  "Docker",
  "LangChain",
  "TensorFlow",
  "OpenCV",
  "SQL",
  "Streamlit",
  "Pandas",
  "Git",
  "C++",
  "Power BI"
];